<script setup lang="ts">
import { buttonVariants } from "."
import { cn } from "@/lib/utils"
import { Loader2 } from "lucide-vue-next"

interface Props {
  variant?: NonNullable<Parameters<typeof buttonVariants>[0]>["variant"]
  size?: NonNullable<Parameters<typeof buttonVariants>[0]>["size"]
  as?: string
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  as: "button",
  loading: false,
})
</script>

<template>
  <component
    :is="as"
    :disabled="loading"
    :class="cn(buttonVariants({ variant, size }), $attrs.class ?? '')"
  >
    <template v-if="loading">
      <div class="flex items-center justify-center">
        <Loader2 class="h-5 w-5 animate-spin" />
      </div>
    </template>
    <template v-else-if="variant === 'secondary'">
      <span
        class="border-afbranding-text text-afbranding-text border-b hover:border-transparent hover:font-bold"
      >
        <slot />
      </span>
    </template>
    <template v-else>
      <slot />
    </template>
  </component>
</template>
